<template>
  <div>
    <div v-if="$route.path.indexOf('_detail') === -1">
      <el-row :gutter="20">
        <el-col :span="4">
          <el-button type="primary" icon="plus" @click="editInfo()">添加banner</el-button>
        </el-col>
      </el-row>

      <el-tabs type="border-card" v-model="type" @tab-click="handleClick">
        <el-tab-pane label="全部" name="0"></el-tab-pane>
        <el-tab-pane v-for="item in options" :key="item.value" :label="item.label" :name="item.value"></el-tab-pane>
      <el-table :data="iconsData" :height="wheight-210"  v-loading="loading"  @selection-change="handleSelectionChange">
        <el-table-column type="selection" align="center" label="全选"></el-table-column>
        <el-table-column prop="id" label="ID" width="50"></el-table-column>
        <el-table-column label="图片" width="100">
          <template slot-scope="scope">
            <el-popover placement="right" width="240" trigger="hover">
            <img :src="scope.row.pic_url" style="width:100%;">
            <el-button type="text" slot="reference"><img style="width:50px;height:50px;" :src="scope.row.pic_url"></el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="pic_name" label="标题" width="130"></el-table-column>

        <el-table-column prop="pic_tag" label="标签" width="130"></el-table-column>
        <el-table-column prop="description" label="内容描述" width="130"></el-table-column>

        <el-table-column prop="type" label="分类" width="140">
          <template slot-scope="scope">
            <span v-if="scope.row.type=='1'">怡贝首页banner</span>
            <span v-else-if="scope.row.type=='2'">怡贝首页icon</span>
            <span v-else-if="scope.row.type=='3'">怡贝首页广告图</span>
            <span v-else-if="scope.row.type=='4'">怡贝首页品牌闪购</span>
            <span v-else>怡贝首页热销商品</span>
          </template>
        </el-table-column>

        <el-table-column prop="pic_order" label="排序(倒序)" width="80">
          <template slot-scope="scope">
            <input v-model="scope.row.pic_order"  @change="sortEdit(node, scope.row)" style="width: 50px;border: 1px solid #ddd;line-height: 25px;padding-left: 5px;"/>
          </template>
        </el-table-column>

        <el-table-column label="活动时间" width="190">
          <template slot-scope="scope">
            {{scope.row.start_date}} <span class="text-muted">开始</span>
            {{scope.row.end_date}} <span class="text-muted">结束</span>
          </template>
        </el-table-column>
        <el-table-column prop="send_date" label="推送时间" width="200"></el-table-column>
        <el-table-column prop="status" label="启用" width="50">
          <template slot-scope="scope">
            <span v-if="scope.row.status=='1'">是</span>
            <span v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column prop="send_status" label="立即推送" width="50">
          <template slot-scope="scope">
            <span v-if="scope.row.send_status=='1'">是</span>
            <span v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column prop="ds_send_status" label="定时推送" width="50">
          <template slot-scope="scope">
            <span v-if="scope.row.ds_send_status=='1'">是</span>
            <span v-else>否</span>
          </template>
        </el-table-column>
<!--        <el-table-column prop="created_date" label="创建时间" width="200"></el-table-column>-->
        <el-table-column label="操作" width="130">
          <template slot-scope="scope">
            <el-button type="text" @click="editInfo(scope.row)" class="btn-gap">编辑</el-button>
            <el-popover
              placement="right"
              width="450"
              trigger="hover">
              <div class="operating-icons">
                <el-button type="text" @click="deleteBannericonAction(scope.$index, scope.row)" class="btn-gap">删除</el-button>
              </div>
              <el-button type="text" slot="reference"><i class="iconfont icon-angle-double-right"></i></el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      </el-tabs>
     <div v-if="total_count > params.pageSize" class="content-padded tc">
      <el-pagination background   layout="prev, pager, next, total" @current-change="handleCurrentChange" :current-page.sync="params.page" :total='total_count' :page-size='params.pageSize'>
      </el-pagination>
    </div>

      <el-dialog  :title="dialogTitle" class="right-dialog" :visible.sync="editInfoDialog" :before-close="handleCancelLabelsDialog">
      <template>
        <el-form>
          <el-form-item label-width="100px" label="标题">
            <el-input v-model="updateForm.pic_name" placeholder="标题"></el-input>
          </el-form-item>
          <el-form-item label-width="100px" label="分类">
            <el-select v-model="updateForm.type" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label-width="100px" label="图片" prop="pic_url">
            <div @click="handleImgPicker('pic_url')" class="upload-box">
              <img v-if="updateForm.pic_url" :src="updateForm.pic_url" class="avatar"/>
              <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
            </div>
            <!-- <div class="frm-tips">
              只能上传jpg/png文件，且不超过2M
            </div> -->
          </el-form-item>
<!--          <el-form-item label-width="100px" label="标签">-->
<!--            <el-input v-model="updateForm.pic_tag" placeholder="标签"></el-input>-->
<!--          </el-form-item>-->
          <el-form-item label-width="100px" label="标签">
            <el-select v-model="updateForm.pic_tag" placeholder="请选择">
              <el-option
                v-for="item in pic_tag"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label-width="100px" label="内容描述">
            <el-input v-model="updateForm.description" placeholder="内容描述"></el-input>
          </el-form-item>
          <el-form-item label-width="100px" label="跳转链接">
            <el-input v-model="updateForm.link" placeholder="跳转链接"></el-input>
          </el-form-item>
          <el-form-item label-width="100px" label="消息推送跳链">
            <el-input v-model="updateForm.sendlink" placeholder="消息推送跳转链接"></el-input>
          </el-form-item>
          <el-form-item label-width="100px" label="排序(倒序)">
            <el-input v-model="updateForm.pic_order" placeholder="排序(倒序)"></el-input>
          </el-form-item>
          <el-form-item label-width="100px" label="启用">
            <el-radio-group v-model="updateForm.status" size="small">
              <el-radio-button :label="'0'">否</el-radio-button>
              <el-radio-button :label="'1'">是</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label-width="100px" label="立即推送">
            <el-radio-group v-model="updateForm.send_status" size="small">
              <el-radio-button :label="'0'">否</el-radio-button>
              <el-radio-button :label="'1'">是</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label-width="100px" label="定时推送">
            <el-radio-group v-model="updateForm.ds_send_status" size="small">
              <el-radio-button :label="'0'">否</el-radio-button>
              <el-radio-button :label="'1'">是</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label-width="100px" label="活动时间">
            <el-col :span="20">
              <el-date-picker
                v-model="activity_date"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']">
              </el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item label-width="100px" label="开始推送时间">
            <el-col :span="20">
              <el-date-picker v-model="send_date" type="datetime" placeholder="选择时间" value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item class="content-center">
            <el-button type="primary" @click="editInfoSubmit()">确定</el-button>
          </el-form-item>
        </el-form>
      </template>
    </el-dialog>

    <imgPicker
      :dialog-visible="imgDialog"
      :sc-status="isGetImage"
      @chooseImg="pickImg"
      @closeImgDialog="closeImgDialog"
    ></imgPicker>

    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import {deleteBannericon, bannericonList, updateBannericon, bannerSortEdit} from '../../../api/sharer'
import imgPicker from '@/components/imageselect'
import {mapGetters} from "vuex";
export default {
  components: { imgPicker },
  data () {
    return {
      total_count: 0,
      dialogTitle: '',
      loading: false,
      iconsData: [],
      params: {
        page: 1,
        pageSize: 20
      },
      updateForm: {
      },
      options: [{
        value: '1',
        label: '怡贝首页banner'
      }, {
        value: '2',
        label: '怡贝首页icon'
      }, {
        value: '3',
        label: '怡贝首页广告图'
      }, {
        value: '4',
        label: '怡贝首页品牌闪购'
      }, {
        value: '5',
        label: '怡贝首页热销商品'
      }],
      pic_tag: [{
        value: 'keyword',
        label: 'keyword'
      }, {
        value: 'cat_id',
        label: 'cat_id'
      }, {
        value: 'h5',
        label: 'h5'
      }],
      activity_date: '',
      send_date: '',
      editInfoDialog: false,
      pickerImgType: '',
      imgDialog: false,
      isGetImage: false,
      type: 0
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  methods: {
    getIcons (filter) {
      this.loading = true
      bannericonList(filter).then(response => {
        this.iconsData = response.data.data.list
        this.total_count = Number(response.data.data.total_count)
        this.loading = false
      })
    },
    editInfo (row = '') {
      this.editInfoDialog = true
      if (row) {
        this.updateForm = row
        this.activity_date = [row.start_date, row.end_date]
        this.send_date = row.send_date
        this.dialogTitle = '编辑Banner'
      } else {
        this.dialogTitle = '添加Banner'
        this.updateForm = {id: '', pic_tag: 'keyword', pic_url: '', pic_order: '0', status: '0', send_status: '0', ds_send_status: '0', starttime: '', endtime: ''}
        this.activity_date = ''
        this.send_date = ''
      }
    },
    editInfoSubmit () {
      if (this.activity_date.length > 0) {
        this.updateForm.starttime = this.activity_date[0]
        this.updateForm.endtime = this.activity_date[1]
      }
      this.updateForm.sendtime = this.send_date
      updateBannericon(this.updateForm).then(res => {
        this.$message({type: 'success', message: '更新成功'})
        this.editInfoDialog = false
        this.getIcons(this.params)
      })
    },
    sortEdit(node, row) {
      let params = {
        'id': row.id,
        'pic_order': row.pic_order ,
      }
      bannerSortEdit(params).then(res => {
        if (res.data.data) {
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 2 * 1000
          })
        }
      })
    },
    deleteBannericonAction (index, row) {
      this.$confirm('此操作将删除该条Banner, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteBannericon(row.id).then(response => {
          if (response.data.data && response.data.data.status) {
            this.iconsData.splice(index, 1)
            this.$message({
              message: '删除Banner成功',
              type: 'success',
              duration: 2 * 1000
            })
          } else {
            this.$message({
              type: 'info',
              message: '删除Banner失败'
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    handleCancelLabelsDialog () {
      this.editInfoDialog = false
    },
    pickImg (data) {
      console.log(data)
      this.updateForm[this.pickerImgType] = data.url
      // this.updateForm.pic_url = data.url
      this.imgDialog = false
    },
    handleImgPicker (pickerImgType) {
      this.pickerImgType = pickerImgType
      this.imgDialog = true
      this.isGetImage = true
    },
    closeImgDialog () {
      this.imgDialog = false
      this.isGetImage = false
    },
    handleSelectionChange (val) {
      console.log(val)
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getIcons(this.params)
    },
    // 切换tab
    handleClick (tab, event) {
      this.type = tab.name
      this.params.type = tab.name
      this.params.page = 1
      this.getIcons(this.params)
    }
  },
  mounted () {
    this.getIcons(this.params)
    let param = {
      page: 1,
      pageSize: 100
    }
  },
  watch: {
    // 分页全选-监听数据变化
    iconsData: {
      handler (value) {
        if (this.allCheck) {
          this.iconsData.forEach(row => {
            if (row) {
              this.$refs.multipleTable.toggleRowSelection(row, true)
            }
          })
        }
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// list.vue?53f44312